import * as ng from 'angular';
import AppConstants from "../gorillaboy/AppConstants";
import {Task} from "../types/TaskTypes";

export interface ITaskDefinitionHelper {
    isDenyAction : (taskDefId : string, actionId: string) => boolean;
    getTaskRequestTypeText: (task: Task) => string;
    getCurrentStatusText: (task: Task) => string;
    takeInternalAction : (task: Task, actionId: string) => void;
    isInternalAction : (task: Task, actionId: string) => boolean;
};


function TasksDefinitionHelperFactory($log : ng.ILogService, $translate: any, $location: ng.ILocationService) : ITaskDefinitionHelper {

    function isInternalAction(task: Task, actionId: string) : boolean {
        if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.REQUEST_FEEDBACK && actionId === "GIVEFEEDBACK") {
            return true;
        }
        return false;
    }

    function takeInternalAction(task: Task, actionId: string) : void {
        if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.REQUEST_FEEDBACK && actionId === "GIVEFEEDBACK") {
            $location.url("/document/" + encodeURIComponent(task.RelatedResourceId) + "?showFeedback=true");
        }
    }

    function isDenyAction(taskDefId: string, actionId: string) {
        if ((taskDefId === AppConstants.TASKDEF_IDS.REQUEST_ACCESS ||
            taskDefId === AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP) && actionId === 'REJECT') {
            return true;
        }
        if (taskDefId === AppConstants.TASKDEF_IDS.REQUEST_FEEDBACK && actionId === 'REJECTFEEDBACKREQUEST') {
            return true;
        }
        return false;
    }

    function getCurrentStatusText(task: Task): string {
        var status = task.State;

        if (task.TaskDefinitionId === AppConstants.TASKDEF_IDS.REQUEST_FEEDBACK) {
            return $translate.instant('TASKS.LIST_VIEW.STATE.REQUEST_FEEDBACK_TASK.' + status);
        }
        if (status == AppConstants.Tasks.State.APPROVE) {
            return $translate.instant('TASKS.LIST_VIEW.STATE.APPROVE');
        } else if (status == AppConstants.Tasks.State.REJECT) {
            return $translate.instant('TASKS.LIST_VIEW.STATE.REJECT');
        } else if (status == AppConstants.Tasks.State.COMPLETE) {
            return $translate.instant('TASKS.LIST_VIEW.STATE.CLOSED');
        } else {
            return $translate.instant('TASKS.LIST_VIEW.STATE.PENDING');
        }
    }

    function getTaskRequestTypeText(task: Task) : string {
        switch (task.TaskDefinitionId) {
            case AppConstants.TASKDEF_IDS.REQUEST_FEEDBACK:
                return $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.REQUEST_FEEDBACK);
            case AppConstants.TASKDEF_IDS.REQUEST_ACCESS:
                return $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.REQUEST_ACCESS);
            case AppConstants.TASKDEF_IDS.NOTIFY_ADMIN_TO_DO:
                return $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.NOTIFY_ADMIN_TO_DO);
            case AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP:
                return $translate.instant('TASKS.TASK_TYPE_NAMES.' + AppConstants.TASK_TYPES.TRANSFER_RESOURCE_OWNERSHIP);
            default:
                return '';
        }
    }

    return {
        isDenyAction,
        getCurrentStatusText,
        getTaskRequestTypeText,
        takeInternalAction,
        isInternalAction
    };
}

TasksDefinitionHelperFactory.$inject = ['$log', '$translate', '$location'];

angular.module('GorillaBoy.Tasks')
    .factory('TaskDefinitionHelper', TasksDefinitionHelperFactory);

